export const STRING_REGEX: RegExp = /[\x00-\x1f\x7f]+/; // eslint-disable-line no-control-regex
